import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import './style.scss';

/**
 * Warning Component when ignore switch is turned on
 */
function IgnoreWarning() {
  return (
    <div className="m16 p16 warning-container">
      <div><FontAwesomeIcon className="warning-icon mr16" size="lg" icon={faExclamationCircle} /></div>
      <div className="text-container">
        <p className="arc-font-weight-400 primary-warning-text">This activity is not being tracked</p>
        <p className="arc-font-weight-400 secondary-warning-text">Turn off the toggle to map it to a record</p>
      </div>
    </div>
  );
}

export default IgnoreWarning;
